import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiLogOut, FiUser } from 'react-icons/fi';
import './MobileHeader.css';

const MobileHeader = () => {
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(false);
    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        const checkAuth = () => {
            setIsAdmin(localStorage.getItem('adminLoggedIn') === 'true');
        };

        checkAuth();
        // Check periodically and on storage events
        const interval = setInterval(checkAuth, 1000);
        window.addEventListener('storage', checkAuth);

        return () => {
            clearInterval(interval);
            window.removeEventListener('storage', checkAuth);
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('adminLoggedIn');
        localStorage.removeItem('adminLoginTime');
        localStorage.removeItem('adminRememberMe');
        setIsAdmin(false);
        setShowMenu(false);
        navigate('/');
        // window.location.reload(); // Removed reload to keep it smooth, state update handles UI
    };

    const handleUserClick = () => {
        if (isAdmin) {
            setShowMenu(!showMenu);
        } else {
            navigate('/admin/login');
        }
    };

    return (
        <header className="mobile-header">
            <Link to="/" className="mobile-logo" style={{ marginRight: 'auto' }}>
                <img src="/logo (2).png" alt="WallZ Logo" />
            </Link>

            <div className="header-side-actions" style={{ position: 'relative' }}>
                <button
                    onClick={handleUserClick}
                    className="mobile-admin-btn"
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: isAdmin ? 'var(--accent-primary)' : '#fff',
                        fontSize: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        padding: '5px'
                    }}
                >
                    <FiUser />
                    {isAdmin && <span style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        width: '8px',
                        height: '8px',
                        background: 'var(--success-color, #4cd964)',
                        borderRadius: '50%',
                        border: '1px solid #000'
                    }}></span>}
                </button>

                {showMenu && isAdmin && (
                    <div className="admin-dropdown-menu" style={{
                        position: 'absolute',
                        top: '100%',
                        right: '0',
                        marginTop: '10px',
                        background: '#1a1a1a',
                        border: '1px solid rgba(255,255,255,0.1)',
                        borderRadius: '12px',
                        padding: '10px',
                        minWidth: '150px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
                        zIndex: 1000,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px'
                    }}>
                        <div style={{
                            padding: '10px',
                            borderBottom: '1px solid rgba(255,255,255,0.05)',
                            marginBottom: '5px',
                            fontSize: '11px',
                            color: 'rgba(255,255,255,0.5)',
                            textTransform: 'uppercase'
                        }}>
                            Admin Access
                        </div>
                        <button
                            onClick={() => {
                                navigate('/admin/orders');
                                setShowMenu(false);
                            }}
                            style={{
                                background: 'rgba(255,255,255,0.05)',
                                border: 'none',
                                color: '#fff',
                                padding: '12px',
                                borderRadius: '8px',
                                textAlign: 'left',
                                cursor: 'pointer',
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}
                        >
                            <span>📊</span> Dashboard
                        </button>
                        <button
                            onClick={handleLogout}
                            style={{
                                background: 'rgba(255,50,50,0.1)',
                                border: 'none',
                                color: '#ff4444',
                                padding: '12px',
                                borderRadius: '8px',
                                textAlign: 'left',
                                cursor: 'pointer',
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}
                        >
                            <FiLogOut /> Logout
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
};

export default MobileHeader;
